import {
	ApiError,
	SurveyAnswerOptionModel,
	SurveyModel,
	routes__clubs__tags__ClubsTagsRouter__MemberTagModel
} from '../../../api-client';
import { IErrorResponse } from '../../../data-models/response/error/ErrorResponse';

/**
 * Declares valid request methods for the RestApiClientModel
 */
export enum HttpMethodEnum {
	POST = 'POST',
	PUT = 'PUT',
	DELETE = 'DELETE',
	GET = 'GET'
}

/**
 * Response received by Axios after a request to our api
 */
export type AxiosResponseWrapper<T> = {
	/**
	 * Base Http Response wrapped by Axios
	 */
	response: BaseHttpResponse<T>;
};

/**
 * Base Http Response returned by our api
 */
export type BaseHttpResponse<T> = {
	/**
	 * Status code of the response
	 */
	status: number;
	/**
	 * Data response from the endpoint
	 */
	data?: T;
	/**
	 * Error response from the endpoint
	 */
	error?: IErrorResponse;
};

export type HttpRequestParams<TBody = unknown> =
	| {
			method: HttpMethodEnum.GET;
	  }
	| {
			method: HttpMethodEnum.DELETE;
			body: TBody;
	  }
	| {
			method: HttpMethodEnum.POST;
			body: TBody;
	  }
	| {
			method: HttpMethodEnum.PUT;
			body: TBody;
	  };

export type MemberTagModel = routes__clubs__tags__ClubsTagsRouter__MemberTagModel;

export type SurveyDataModel = SurveyModel;

export type SurveyAnswerOptionDataModel = SurveyAnswerOptionModel;

type ApiErrorResponseBody = {
	/**
	 * The detailed message that our API returns
	 */
	detail?: string;
};

/**
 * Extend the predefined ApiError to type body correctly
 */
export class ApiErrorResponse extends ApiError {
	public readonly body: ApiErrorResponseBody = {};
}
